//login
import Login from './components/views/layouts/Login';
//panel
import Panel from './components/views/layouts/Panel';
import Home from '@/components/views/home/Home.vue';
import Help from "./components/partials/Help";

import Administration from './routes/Administration/Administration';
import Form from './routes/Form';
import User from './routes/Administration/User';
import Profile from './routes/Administration/Profile';
import Office from './routes/Administration/Office';

export const routes = [
    {
        path: '/ingresar',
        component: Login,
        beforeEnter: (to, from, next) => {

            if (sessionStorage.getItem('acquisition_token')) {
                next('/');
            } else {
                next();
            }
        }
    },
    {
        path: '/',
        component: Panel,
        children: [
            {
                path: '',
                component: Home
            },
            {
                path: '/help',
                component: Help
            },
            {...Form},
            {...Administration}
        ],

        beforeEnter: (to, from, next) => {
            if (sessionStorage.getItem('acquisition_token_expiration')) {
                next();
            } else {
                next('/ingresar');
            }
        }
    },
    {path: '*', redirect: '/'}
];
